/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import { ExceptionCodeErrorData } from 'services/api/responses/responseTypes';
import messages from 'services/locales/en/messages';

export const transformToError = (data: ExceptionCodeErrorData) => {
  const { payload } = data;
  if (!payload) {
    return { message: data.error_description };
  }

  const { exception_code } = payload;
  if (exception_code) {
    return { code: exception_code, message: data.error_description };
  }

  return { message: messages.error.unknown };
};
